import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { rejectTask } from 'api/task.service';

export const useTaskRejectQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(
    ({ id }: { id: string }) => rejectTask(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['tasks']);
        toast.success('Task rejected successfully');
      },
      onError: (error: AxiosError) => {
        toast.error(error.message);
      },
    },
  );

  return { isLoading, mutate };
};
